import { useEffect } from 'react';
import { companyInfo } from '../data/mock';

const InstagramFeed = () => {
  useEffect(() => {
    // Load Curator.io script
    if (!document.querySelector('script[src*="curator.io"]')) {
      const script = document.createElement('script');
      script.src = 'https://cdn.curator.io/published/970e5edd-e2a3-4d04-9d57-03b55d459ff0.js';
      script.async = true;
      script.charset = 'UTF-8';
      document.body.appendChild(script);
    }
  }, []);

  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-gray-900">
            Follow Us on Instagram
          </h2>
          <p className="text-lg text-gray-600 mt-3 max-w-2xl mx-auto">
            See our latest moves, happy customers, and behind-the-scenes action
          </p>
          <a 
            href={companyInfo.social.instagram} 
            target="_blank" 
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 mt-4 px-6 py-2.5 bg-gradient-to-r from-purple-600 via-pink-500 to-orange-400 text-white font-semibold rounded-full hover:opacity-90 transition-opacity text-sm"
            data-testid="instagram-follow-link"
          >
            <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/></svg>
            Follow @{companyInfo.social.instagram.replace(/\/$/, '').split('/').pop()}
          </a>
        </div>
        <style>{`
          #curator-feed-default-feed-layout [class^="crt-col-"] .crt-post:nth-child(n+2) {
            display: none !important;
          }
          #curator-feed-default-feed-layout .crt-load-more {
            display: none !important;
          }
          #curator-feed-default-feed-layout .crt-feed-scroll {
            height: auto !important;
            max-height: none !important;
            overflow: visible !important;
          }
        `}</style>
        <div id="curator-feed-default-feed-layout" data-testid="instagram-feed">
          <a href="https://curator.io" target="_blank" rel="noopener noreferrer" className="crt-logo crt-tag">
            Powered by Curator.io
          </a>
        </div>
      </div>
    </section>
  );
};

export default InstagramFeed;
